import PropTypes from "prop-types";
import { styled } from "styled-components";
const propTypes = {
  columns: PropTypes.number,
  magnitude: PropTypes.oneOf(["small", "large"])
};
const defaultProps = {
  columns: 7,
  magnitude: "small"
};
const CalendarGrid = styled("div")(
  {
    alignItems: "stretch",
    display: "grid",
    gap: 8,
    justifyContent: "center"
  },
  ({ columns, magnitude }) => {
    const [width, height] = {
      large: [66, 32],
      small: [24, 24]
    }[magnitude];
    return {
      gridAutoRows: `${height}px`,
      gridTemplateColumns: `repeat(${columns}, ${width}px)`
    };
  }
);
CalendarGrid.propTypes = propTypes;
CalendarGrid.defaultProps = defaultProps;
export {
  CalendarGrid
};
